import { createSceneFromFit, fitroomViewportModuleContext } from '@seddi/ui-babylon-fitroom';
import log from 'loglevel';
import { fetchFit } from '../../closets';
import { homeActions } from '../slices/homeSlice';
import { HomeDispatch } from '../store/homeStore';
import { homeStateExt } from '../store/homeStateExt';

type PollState = {
  timer?: any;
};

const GARMENT_FIT_POLL_MILLISECONDS = 2000;

const state: PollState = {
  timer: undefined,
};

/**
 * Begin garment fit polling loop.
 * @param avatarId The avatar id.
 * @param garmentId The garment id.
 */
export function beginFitPoll(
  dispatch: HomeDispatch,
  avatarId: string,
  garmentId: string,
  poseId: string,
) {
  // End previous interval.
  endFitPoll(dispatch);

  log.info('Fit poll begin');

  dispatch(homeActions.beginFit());

  // initialize a new interval with the latest garment fit request
  state.timer = setInterval(async () => {
    const fit = (await fetchFit(avatarId, garmentId, poseId))!;

    if (fit.geometrySurfaceStatus !== 'COMPLETED') {
      return;
    }

    // Garment fit completed finish poll
    endFitPoll(dispatch);

    log.info('Fit poll ended');

    // Show garment on viewport
    const garment = homeStateExt.garment!;
    const scene = createSceneFromFit(garment, fit)!;
    const context = fitroomViewportModuleContext();
    context.updateGarment(scene);
  }, GARMENT_FIT_POLL_MILLISECONDS);
}

/**
 * Finish existing garment fit polling.
 */
export function endFitPoll(dispatch: HomeDispatch) {
  if (state.timer) {
    // clear interval
    clearInterval(state.timer);
    state.timer = undefined;

    dispatch(homeActions.endFit());
  }
}
